import React, { useEffect } from 'react';
import { Row, Col, Card, Button } from 'antd'
import { useSelector, useDispatch } from 'react-redux';
import NumberFormat from 'react-number-format';
import { Link } from 'react-router-dom'
import { actionGetConfigTarifasRequest, actionGetProductDetail } from '../../store/acciones/accionesProductos';
import item_product from '../../assets/images/item_product.png'
// import logoNfh from '../../assets/images/logonfh.png'
import './styles.css';
import { useParams } from 'react-router-dom'
import ListImageProductView from './ListImageProductView';


const renderImage = (item) => {
    var extension = '.pdf';
    if (item.image_product && item.image_product.length > 0) {
        let filterImageExtension = item.image_product.filter(function (file) {
            return file.image_product.indexOf(extension) == -1;
        });
        return <ListImageProductView images={filterImageExtension} />
    }

    else
        return <img src={item_product} style={{ width: "80%", height: "80%", objectFit: "contain" }} alt={item.nombre_producto} />
}

const renderPDF = (item) => {
    var extension = '.pdf';
    if (item.image_product && item.image_product.length > 0) {
        let filterImageExtension = item.image_product.filter(function (file) {
            return file.image_product.indexOf(extension) !== -1;
        });
        console.log(filterImageExtension)
        return <div className="divFichaTecnica">
            {filterImageExtension.map(item => {
                return <Button size="large" href={item.image_product} icon="file-pdf" target="blank" key={item.id} className="linkFicha" >Ficha tecnica</Button>
            })}

        </div>
    }

    else
        return null
}

const ProductDetail = (props) => {
    const dispatch = useDispatch();
    let { idProducto } = useParams();
    let item = useSelector(state => state.reducerProductos.detailProduct);
    let configTarifas = useSelector(state => state.reducerProductos.configTarifas);

    console.log('Config tarifas', configTarifas)
    useEffect(() => {
        dispatch(actionGetProductDetail(idProducto))
        dispatch(actionGetConfigTarifasRequest())
    }, [dispatch])


    function CalcularPorcentaje(tipoTarifa, tarifa) {
        if (tipoTarifa) {
            return tarifa * (tipoTarifa / 100) + tarifa
        }
        else return tarifa
    }

    function CalcularPorcentaje(tipoTarifa, tarifa) {
        if (configTarifas) {
            switch (tipoTarifa) {
                case 'tarjeta_debito':
                    return tarifa * (configTarifas.tarjeta_debito / 100) + tarifa
                case 'tarjeta_credito':
                    return tarifa * (configTarifas.tarjeta_credito / 100) + tarifa
                case 'pago_tres_meses':
                    return tarifa * (configTarifas.pago_tres_meses / 100) + tarifa
                case 'pago_seis_meses':
                    return tarifa * (configTarifas.pago_seis_meses / 100) + tarifa
                default: {
                    return tarifa;
                }
            }
        }
        else {
            return tarifa
        }
    }

    if (!item) {
        return null
    }


    console.log(configTarifas)
    console.log(item)
    return (
        <div style={{ width: "100%" }}>
            <div className="divSection">
                <div className="container-fluid">
                    <div className="logo" >
                        <h1><a href="#intro" className="scrollto">NFH</a></h1>
                    </div>
                    <nav className="nav-menu-container">
                        <ul className="nav-menu">
                            <li><a href="http://www.nfh.com.mx/#intro">Inicio</a></li>
                            <li><a href="http://www.nfh.com.mx/#about">Nosotros</a></li>
                            <li><a href="http://www.nfh.com.mx/#services">Servicios</a></li>
                            <li><a href="http://www.nfh.com.mx/#portfolio">Productos</a></li>
                            <li><a href="http://www.nfh.com.mx/#sucursales">Sucursales</a></li>
                            <li><a href="http://www.nfh.com.mx/#contact">Contacto</a></li>
                            <li className="menu-active"><a href="#">Catalogo</a></li>
                        </ul>
                    </nav>
                </div>

            </div>
            <Row type="flex" align="top" justify="center" className="containerDataDetail" >
                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24} style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                    <span style={{ fontSize: "30px", fontWeight: "bold", letterSpacing: "1px", margin: "10px 0 10px 0", padding:5 }}>{item.nombre_producto}</span>
                    {
                        item && item.image_product && item.image_product.length > 0 ?
                            renderImage(item)
                            // <img  src={item.image_product[0].image_product}style={{ width: "60%", height: "60%", objectFit: "contain" }} alt={item.nombre_producto} />
                            :
                            <img src={item_product} style={{ width: "40%", height: "40%", objectFit: "contain" }} alt={item.nombre_producto} />
                    }
                    {
                        item && item.image_product && item.image_product.length > 0 ? renderPDF(item) : <div>No hay ficha tecnica</div>
                    }
                </Col>

                <Col xxl={10} xl={10} lg={10} md={10} sm={24} xs={23} style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
                    <span style={{ fontSize: 16, fontWeight: "700", letterSpacing: "1.5px", marginBottom: "15px" }}>Id Material: {item.clave_producto}</span>
                    {
                        item.descripcion_producto &&
                        <span style={{ fontSize: 16, fontWeight: "700", letterSpacing: "1.5px", marginBottom: "10px" }}>{item.descripcion_producto}</span>
                    }
                    <Card style={{ marginTop: 20 }}>
                        <span style={{ fontSize: "20px", fontWeight: "800", letterSpacing: "1px" }}>Pago en efectivo, cheque o transferencia</span>
                        <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center", marginBottom: "20px" }}>
                            <span style={{ fontSize: 30, fontWeight: "800", letterSpacing: "1px", margin: "10 0 10 0" }}> <NumberFormat value={item.precio_publico} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} /></span>
                            <span style={{ fontSize: 18, fontWeight: "800", letterSpacing: "1px", margin: "10 0 10 0" }}>{item.medida_producto}</span>
                        </div>
                        <div >*Los cheques se reciben salvo buen cobro y todas las transferencias sin excepción deben de ser verificadas</div>
                    </Card>
                    <Card style={{ marginTop: 20 }}>
                        <span style={{ fontSize: "20px", fontWeight: "800", letterSpacing: "1px" }}>Pago Debito</span>
                        <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center", marginBottom: "20px" }}>
                            <span style={{ fontSize: 30, fontWeight: "800", letterSpacing: "1px", margin: "10 0 10 0" }}> <NumberFormat value={CalcularPorcentaje('tarjeta_debito', item.precio_publico)} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} /></span>
                            <span style={{ fontSize: 18, fontWeight: "800", letterSpacing: "1px", margin: "10 0 10 0" }}>{item.medida_producto}</span>
                        </div>
                    </Card>
                    <Card style={{ marginTop: 20 }}>
                        <span style={{ fontSize: "20px", fontWeight: "800", letterSpacing: "1px" }}>Pago Credito</span>
                        <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center", marginBottom: "20px" }}>
                            <span style={{ fontSize: 30, fontWeight: "800", letterSpacing: "1px", margin: "10 0 10 0" }}> <NumberFormat value={CalcularPorcentaje('tarjeta_credito', item.precio_publico)} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} /></span>
                            <span style={{ fontSize: 18, fontWeight: "800", letterSpacing: "1px", margin: "10 0 10 0" }}>{item.medida_producto}</span>
                        </div>
                    </Card>
                    <Card style={{ marginTop: 20 }}>
                        <span style={{ fontSize: "20px", fontWeight: "800", letterSpacing: "1px" }}>Pago 3 meses</span>
                        <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center", marginBottom: "20px" }}>
                            <span style={{ fontSize: 30, fontWeight: "800", letterSpacing: "1px", margin: "10 0 10 0" }}> <NumberFormat value={CalcularPorcentaje('pago_tres_meses', item.precio_publico)} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} /></span>
                            <span style={{ fontSize: 18, fontWeight: "800", letterSpacing: "1px", margin: "10 0 10 0" }}>{item.medida_producto}</span>
                        </div>
                    </Card>
                    <Card style={{ marginTop: 20 }}>
                        <span style={{ fontSize: "20px", fontWeight: "800", letterSpacing: "1px" }}>Pago 6 meses</span>
                        <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center", marginBottom: "20px" }}>
                            <span style={{ fontSize: 30, fontWeight: "800", letterSpacing: "1px", margin: "10 0 10 0" }}> <NumberFormat value={CalcularPorcentaje('pago_seis_meses', item.precio_publico)} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} /></span>
                            <span style={{ fontSize: 18, fontWeight: "800", letterSpacing: "1px", margin: "10 0 10 0" }}>{item.medida_producto}</span>
                        </div>
                    </Card>

                    {
                        item.info_product && item.info_product.file_product &&
                        <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center", marginBottom: "20px" }}>
                            file product
                        </div>
                    }


                </Col>
            </Row>
            <Row>
                <Col xl={24} lg={24} md={24} xs={24} className="divLista">
                    <ul className="ulCondiciones"> 
                        <li>Los precios incluyen IVA.</li>
                        <li>Los precios están sujetos a disponibilidad del producto y son hasta agotar existencias.</li>
                        <li>Le entrega de los productos sin costo es dentro de la ciudad de Pachuca y zonas conurbadas y está sujeta a ser agendada por el personal encargado de la sucursal.</li>
                        <li>Nacional Ferretera de Hidalgo SA de CV se reserva el cambio de precios sin aviso previo alguno.</li>
                    </ul>
                </Col>
            </Row>
        </div>

    );
};

export default ProductDetail;